import {Component, OnInit} from '@angular/core';
import {SectionBase} from '../../../components/section/section-base';
import {
    OfferModificationsService
} from '../../../../core/services/impl/offer-modifications/offer-modifications.service';
import {OfferModificationDestination} from '../../../../core/consts/offer-modification-destination.enum';
import {OfferModification} from '../../../../core/models/offer/offer-modification.model';
import {
    AcVariantsModificationOption,
    OfferModificationCode
} from '../../../../core/consts/offer-modification-code.enum';
import {AcVariantsSectionConfig} from './ac-variants-section.config';
import {LanguageService} from '../../../services/language.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {BusinessParamName} from '../../../models/request-offer/request-offer.enum';
import {InsuranceCompanyCode} from '../../../models/insurance-company-code.enum';
import {ApplicationStateService} from '../../../services/application-state.service';
import {isSkycash} from '../../../../core/utils/utils';
import {Validators} from '@angular/forms';
import {
    OfferModificationConfig,
    OfferModificationsConfigService
} from '../../../../core/services/impl/offer-modifications/offer-modifications-config.service';
import {Subscription} from 'rxjs/Rx';
import {
    AcVariantsComparisonsDialogComponent
} from '../ac-variants-beesafe-section/ac-variants-comparisons-dialog/ac-variants-comparisons-dialog.component';
import {MatDialog} from '@angular/material';
import {
    LoadingContentPlaceholderCellSize,
    LoadingContentPlaceholderConfig,
    LoadingContentPlaceholderType
} from '../../../components/presentation/loading-content-placeholder/loading-content-placeholder.component';
import {OfferResponseStatusCode} from '../../../../core/enums/offer/offer-response-status-code.enum';

@Component({
    selector: 'app-ac-variants-section',
    templateUrl: './ac-variants-section.component.html',
    styleUrls: ['./ac-variants-section.component.scss']
})
export class AcVariantsSectionComponent extends SectionBase implements OnInit {

    modificationsConfigs: OfferModificationConfig[];
    modifications: OfferModification[];
    sectionVisible: boolean;
    compareCoveragesAllowed: boolean = false;
    contentVisible: boolean = true;
    loadingContentPlaceholderConfig: LoadingContentPlaceholderConfig = {
        type: LoadingContentPlaceholderType.ADVANCED,
        rows: [
            {
                cells: [
                    {
                        size: LoadingContentPlaceholderCellSize.SMALL
                    },
                    {
                        size: LoadingContentPlaceholderCellSize.LARGE
                    },
                    {
                        size: LoadingContentPlaceholderCellSize.LARGE
                    },
                    {
                        size: LoadingContentPlaceholderCellSize.LARGE
                    }
                ]
            },
            {
                cells: [
                    {
                        size: LoadingContentPlaceholderCellSize.SMALL
                    },
                    {
                        size: LoadingContentPlaceholderCellSize.LARGE
                    },
                    {
                        size: LoadingContentPlaceholderCellSize.LARGE
                    },
                    {
                        size: LoadingContentPlaceholderCellSize.LARGE
                    }
                ]
            },
            {
                cells: [
                    {
                        size: LoadingContentPlaceholderCellSize.SMALL
                    },
                    {
                        size: LoadingContentPlaceholderCellSize.LARGE
                    },
                    {
                        size: LoadingContentPlaceholderCellSize.LARGE
                    }
                ]
            }
        ]
    }

    private readonly AC_VARIANTS_OPTIONS_ORDER = [
        AcVariantsModificationOption.SERWIS_ASO,
        AcVariantsModificationOption.WARSZTAT_PLUS,
        AcVariantsModificationOption.WARSZTAT,
        AcVariantsModificationOption.KOSZTORYS_BEZ_AMORTYZACJI,
        AcVariantsModificationOption.KOSZTORYS_Z_AMORTYZACJA,
    ];

    private readonly MODIFICATIONS_ORDER = [
        OfferModificationCode.AC_TERRITORIAL_RANGE,
        OfferModificationCode.AC_VARIANT,
        OfferModificationCode.MINICASCO_VARIANT,
        OfferModificationCode.REPAIR_PARTS,
        OfferModificationCode.PARTS_DEPRECIATION,
        OfferModificationCode.AC_EXCESS,
        OfferModificationCode.AC_EXCESS_THIEF,
        OfferModificationCode.AC_GSU,
        OfferModificationCode.RENEWABLE_INSURANCE_AMOUNT,
    ];

    private controlsChangesSubscriptions: Subscription[] = [];

    get visibleModifications(): OfferModification[] {
        return this.modifications.filter(mod => mod.visible);
    }

    get invisibleModifications(): OfferModification[] {
        return this.modifications.filter(mod => !mod.visible);
    }

    get selectedACVariant(): string {
        const acVariantModification = this.modifications.find(mod => mod.code === OfferModificationCode.AC_VARIANT);
        if (isNotNullOrUndefined(acVariantModification)) {
            return acVariantModification.options.find(option => option.selected).value;
        }
        return null;
    }

    get buttonVisible(): boolean {
        return isSkycash() && !this.offerModificationsService.offerCurrentPrice;
    }

    get callCenterSectionVisible(): boolean {
        const atLeastOneInvisibleModificationToDisplay = this.invisibleModifications.some(mod => this.shouldDisplayModification(mod.code));
        return this.offerModificationsService.callCenterMode && atLeastOneInvisibleModificationToDisplay;
    }

    get validInsuranceCompany(): boolean {
        return [InsuranceCompanyCode.UNIQA, InsuranceCompanyCode.PEVNO].includes(this.stateService.getBusinessParameterValue(BusinessParamName.INSURANCE_COMPANY_CODE) as InsuranceCompanyCode);
    }

    constructor(private languageService: LanguageService,
                public offerModificationsService: OfferModificationsService,
                private configService: OfferModificationsConfigService,
                private dialog: MatDialog,
                public stateService: ApplicationStateService) {
        super();
    }

    ngOnInit() {
        this.init();
        const subscription = this.offerModificationsService.getOfferEvent.subscribe(() => {
            subscription.unsubscribe();
            this.init();
        });
    }

    updateValidators(): void {
        if (this.offerModificationsService.minicascoVariantSelectedOption === false) {
            this.getControl(OfferModificationCode.AC_EXCESS_THIEF).clearValidators();
        }
    }

    createConfig(initialConfig = false): void {
        const config = new AcVariantsSectionConfig(this.languageService, this.offerModificationsService);
        this.formConfig = config.createConfig(OfferModificationDestination.AC_VARIANTS, this.modifications, true, initialConfig);
    }

    initBean(): void {
        this.bean = {};
        this.modifications.forEach(modification => {
            const selectedOption = modification.options.find(option => option.selected);
            if (selectedOption) {
                this.bean[modification.code] = selectedOption.value;
            }
        });

        if (this.offerModificationsService.vehicleValueModificationEnabled) {
            this.bean.vehicleValue = this.offerModificationsService.getSelectedOfferVehicleValue() + '';
        }
    }

    initControlsChanges(): void {
        this.controlsChangesSubscriptions.forEach(subscription => subscription.unsubscribe());
        this.controlsChangesSubscriptions = [];
        this.modifications.forEach(modification => this.controlsChangesSubscriptions.push(
            this.getControl(modification.code).valueChanges.subscribe(value => {
                this.handleModificationChange(modification, value);
            }))
        );

        if (this.offerModificationsService.vehicleValueModificationEnabled) {
            this.getControl('vehicleValue').valueChanges.subscribe(vehicleValue => {

            });
        }
    }

    recalculatePremium(): void {
        this.offerModificationsService.recalculatePremium();
    }

    shouldDisplayModification(code: string): boolean {
        if (this.offerModificationsService.hasModification(OfferModificationCode.MINICASCO_VARIANT)) {
            return code !== OfferModificationCode.REPAIR_PARTS && code !== OfferModificationCode.PARTS_DEPRECIATION;
        }
        return true;
    }

    compareCoverages(): void {
        this.dialog.open(AcVariantsComparisonsDialogComponent, AcVariantsComparisonsDialogComponent.getConfigBuilder()
            .buildConfiguration(this.offerModificationsService.getACPricing()))
            .afterClosed().subscribe(acVariant => {
                if (isNotNullOrUndefined(acVariant)) {
                    if ([AcVariantsModificationOption.KOSZTORYS_Z_AMORTYZACJA, AcVariantsModificationOption.KOSZTORYS_BEZ_AMORTYZACJI].includes(acVariant)) {
                        if (acVariant === AcVariantsModificationOption.KOSZTORYS_Z_AMORTYZACJA) {
                            this.getControl(OfferModificationCode.PARTS_DEPRECIATION).setValue(true);
                        } else {
                            this.getControl(OfferModificationCode.PARTS_DEPRECIATION).setValue(false);
                        }
                    }
                    this.getControl(OfferModificationCode.AC_VARIANT).setValue(acVariant);
                }
        });
    }

    private init(): void {
        this.initModifications();
        this.initSectionVisible();
        this.offerModificationsService.acModificationsMode = this.contentVisible;
        if (this.contentVisible) {
            this.updateModificationsWithPresentationModifications();
            this.initBean();
            this.createConfig(true);
            this.buildForm();
            this.initControlsChanges();
            this.updateValidators();
            this.offerModificationsService.modifiedOfferEvent.subscribe(priceChanged => {
                if (isNotNullOrUndefined(priceChanged)) {
                    this.rebuildAllModifications();
                }
            });
        }
    }

    private handleModificationChange(modification: OfferModification, value: any): void {
        if (modification.code === OfferModificationCode.AC_VARIANT) {
            if ([AcVariantsModificationOption.WARSZTAT, AcVariantsModificationOption.WARSZTAT_PLUS, AcVariantsModificationOption.SERWIS_ASO].includes(value)) {
                this.getControl(OfferModificationCode.PARTS_DEPRECIATION).setValue(false, {emitEvent: false});
            }
            if (value === AcVariantsModificationOption.SERWIS_ASO) {
                if (this.offerModificationsService.gsuIncluded) {
                    this.setModificationValue(OfferModificationCode.AC_GSU, true);
                }
                this.setModificationValue(OfferModificationCode.REPAIR_PARTS, 'ORIGINAL', false);
            }
            if (value === AcVariantsModificationOption.WARSZTAT_PLUS) {
                this.setModificationValue(OfferModificationCode.REPAIR_PARTS, 'ORIGINAL', false);
            }

            if (value === AcVariantsModificationOption.WARSZTAT) {
                this.setModificationValue(OfferModificationCode.REPAIR_PARTS, 'REPLACEMENTS', false);
            }

            if (value === AcVariantsModificationOption.KOSZTORYS_BEZ_AMORTYZACJI) {
                this.setModificationValue(OfferModificationCode.REPAIR_PARTS, 'REPLACEMENTS', false);
            }

            if ([AcVariantsModificationOption.KOSZTORYS_BEZ_AMORTYZACJI, AcVariantsModificationOption.KOSZTORYS_Z_AMORTYZACJA].includes(value)) {
                this.setModificationValue(OfferModificationCode.AC_GSU, false);
            }
        }
        if (modification.code === OfferModificationCode.AC_EXCESS) {
            if (value >= 1000) {
                this.getControl(OfferModificationCode.AC_EXCESS_THIEF).setValue(10);
            }
        }
        if (modification.code === OfferModificationCode.MINICASCO_VARIANT) {
            if (value) {
                const originalAcExcessThiefValue = this.offerModificationsService.getSelectedOfferOriginalModificationSelectedOptionValue(OfferModificationCode.AC_EXCESS_THIEF);
                this.getControl(OfferModificationCode.AC_EXCESS_THIEF).setValidators([Validators.required]);
                if (isNotNullOrUndefined(originalAcExcessThiefValue)) {
                    this.getControl(OfferModificationCode.AC_EXCESS_THIEF).setValue(originalAcExcessThiefValue);
                } else {
                    setTimeout(() => {
                        const fieldConfig = this.getFieldConfig(OfferModificationCode.AC_EXCESS_THIEF);
                        if (fieldConfig) {
                            const firstEnabledOption = fieldConfig.radioConfig.find(option => !option['disabled']);
                            if (firstEnabledOption) {
                                this.getControl(OfferModificationCode.AC_EXCESS_THIEF).setValue(firstEnabledOption.value);
                            }
                        }
                    }, 0);
                }
            } else {
                this.getControl(OfferModificationCode.AC_EXCESS_THIEF).clearValidators();
                this.getControl(OfferModificationCode.AC_EXCESS_THIEF).reset();
            }
        }
        if (modification.code === OfferModificationCode.AC_GSU) {
            if (value && this.getControl(OfferModificationCode.AC_VARIANT).value === AcVariantsModificationOption.KOSZTORYS_BEZ_AMORTYZACJI) {
                this.setModificationValue(OfferModificationCode.AC_VARIANT, AcVariantsModificationOption.WARSZTAT);
            }
        }
        if (modification.code === OfferModificationCode.REPAIR_PARTS) {
            if (value === 'REPLACEMENTS') {
                const acVariantValue = this.offerModificationsService.depreciationPartValue ? AcVariantsModificationOption.KOSZTORYS_Z_AMORTYZACJA : AcVariantsModificationOption.KOSZTORYS_BEZ_AMORTYZACJI;
                this.setModificationValue(OfferModificationCode.AC_VARIANT, acVariantValue);
            } else { // ORIGINAL
                this.getControl(OfferModificationCode.AC_VARIANT).setValue(AcVariantsModificationOption.SERWIS_ASO);
            }
        }
        this.offerModificationsService.updateModification(modification.code, value);
        this.offerModificationsService.saveModificationInCache();
        this.rebuildSection();
        if (modification.code === OfferModificationCode.PARTS_DEPRECIATION) {
            const acVariant = this.offerModificationsService.modifications.find(mod => mod.code === OfferModificationCode.AC_VARIANT);
            if (acVariant) {
                const selectedACVariant = acVariant.options.find(option => option.selected).value;
                this.getControl(OfferModificationCode.AC_VARIANT).setValue(selectedACVariant, {emitEvent: false});
            }
        }
    }

    private initModifications(): void {
        if (this.offerModificationsService.modifications && this.offerModificationsService.modifications.length > 0) {
            this.modificationsConfigs = this.configService.getModificationsForDestination(OfferModificationDestination.AC_VARIANTS);
            const codes = this.modificationsConfigs.map(config => config.code);
            this.modifications = this.offerModificationsService.modifications.filter(modification => codes.includes(<OfferModificationCode>modification.code));
            this.compareCoveragesAllowed = isNotNullOrUndefined(this.modifications.find(item => item.code === OfferModificationCode.AC_VARIANT));
            this.sortAcVariantsOptions();
            this.sectionVisible = this.modifications && this.modifications.length > 0;
            this.offerModificationsService.acModificationsMode = this.sectionVisible;
        }
    }

    private sortModifications(): void {
        const sortedModifications = [];
        this.MODIFICATIONS_ORDER.forEach(modificationCode => {
            const modification = this.modifications.find(mod => mod.code === modificationCode);
            if (isNotNullOrUndefined(modification)) {
                sortedModifications.push(modification)
            }
        });
        this.modifications = sortedModifications;
    }

    private sortAcVariantsOptions(): void {
        const acVariantsModification = this.modifications.find(mod => mod.code === OfferModificationCode.AC_VARIANT);
        if (isNotNullOrUndefined(acVariantsModification)) {
            const options = [];
            this.AC_VARIANTS_OPTIONS_ORDER.forEach(optionKey => {
                const modificationOption = acVariantsModification.options.find(option => option.value === optionKey);
                if (isNotNullOrUndefined(modificationOption)) {
                    options.push(modificationOption);
                }
            });
            this.modifications.find(mod => mod.code === OfferModificationCode.AC_VARIANT).options = options;
        }
    }

    private setModificationValue(code: string, value: any, emitEvent = true) {
        if (isNotNullOrUndefined(this.getControl(code)) && this.getControl(code).value !== value) {
            this.getControl(code).setValue(value, {emitEvent: emitEvent});
        }
    }

    private initSectionVisible(): void {
        if (this.offerModificationsService.requiresGetOffer && this.stateService.state.selectedOfferStatusCode !== OfferResponseStatusCode.GET_OFFER) {
            this.sectionVisible = this.validInsuranceCompany;
            this.contentVisible = this.sectionVisible && this.modifications && this.modifications.length > 0;
        } else {
            this.sectionVisible = this.validInsuranceCompany && this.modifications && this.modifications.length > 0;
            this.contentVisible = this.sectionVisible;
        }
    }

    private updateModificationsWithPresentationModifications(): void {
        this.addPartsDepreciationModification();
        this.addRepairPartsModification();
        this.sortModifications();
    }

    private addPartsDepreciationModification(): void {
        this.modifications.push({
            visible: true,
            code: OfferModificationCode.PARTS_DEPRECIATION,
            options: [
                {
                    value: false,
                    selected: this.selectedACVariant !== AcVariantsModificationOption.KOSZTORYS_Z_AMORTYZACJA,
                    labels: [
                        {languageCode: 'PL', description: 'OFFER_MODIFICATIONS.PARTS_DEPRECIATION.abolished'},
                        {languageCode: 'EN', description: 'OFFER_MODIFICATIONS.PARTS_DEPRECIATION.abolished'},
                    ]
                },
                {
                    value: true,
                    selected: this.selectedACVariant === AcVariantsModificationOption.KOSZTORYS_Z_AMORTYZACJA,
                    labels: [
                        {languageCode: 'PL', description: 'OFFER_MODIFICATIONS.PARTS_DEPRECIATION.enabled'},
                        {languageCode: 'EN', description: 'OFFER_MODIFICATIONS.PARTS_DEPRECIATION.enabled'},
                    ]
                }
            ],
            labels: [
                {
                    languageCode: 'PL',
                    description: 'OFFER_MODIFICATIONS.partsDepreciation'
                },
                {languageCode: 'EN', description: 'OFFER_MODIFICATIONS.partsDepreciation'},
            ]
        });
        this.offerModificationsService.depreciationPartValue = this.selectedACVariant === AcVariantsModificationOption.KOSZTORYS_Z_AMORTYZACJA;
    }

    private addRepairPartsModification(): void {
        this.modifications.push({
            visible: true,
            code: OfferModificationCode.REPAIR_PARTS,
            options: [
                {
                    value: 'ORIGINAL',
                    selected: this.selectedACVariant === AcVariantsModificationOption.SERWIS_ASO,
                    labels: [
                        {languageCode: 'PL', description: 'OFFER_MODIFICATIONS.REPAIR_PARTS.original'},
                        {languageCode: 'EN', description: 'OFFER_MODIFICATIONS.REPAIR_PARTS.original'},
                    ]
                },
                {
                    value: 'REPLACEMENTS',
                    selected: this.selectedACVariant !== AcVariantsModificationOption.SERWIS_ASO,
                    labels: [
                        {languageCode: 'PL', description: 'OFFER_MODIFICATIONS.REPAIR_PARTS.replacements'},
                        {languageCode: 'EN', description: 'OFFER_MODIFICATIONS.REPAIR_PARTS.replacements'},
                    ]
                }
            ],
            labels: [
                {
                    languageCode: 'PL',
                    description: 'OFFER_MODIFICATIONS.REPAIR_PARTS.label',
                    tooltip: 'OFFER_MODIFICATIONS.REPAIR_PARTS.tooltip'
                },
                {
                    languageCode: 'EN',
                    description: 'OFFER_MODIFICATIONS.REPAIR_PARTS.label',
                    tooltip: 'OFFER_MODIFICATIONS.REPAIR_PARTS.tooltip'
                },
            ]
        })
    }

    private rebuildSection(): void {
        this.initBean();
        this.createConfig();
        this.buildForm();
    }

    private rebuildAllModifications(): void {
        this.sectionVisible = false;
        this.modifications = null;
        this.initModifications();
        this.initSectionVisible();
        this.updateModificationsWithPresentationModifications();
        this.rebuildSection();
        this.initControlsChanges();
    }
}
